import { contentTagging } from '../../onbrand.js';

const helper = require('../helperFunctions.js');

module.exports = function englishPartial() {
  // custom Hub functions

  let englishLoaded = false;

  Hubs.Events
    .on('load', () => {
      if (!englishLoaded) {
        // Call all on load functions here

        englishLoaded = true;
      }
    })
    .on('itemsLoaded', (itemIds, selectors) => {
      // Call all itemsLoaded events here
    })
    .on('resize', () => {
      // Call all resize events here
    })
    .on('scroll', () => {
      // Call all scroll events here
    })
    .on('ctaActivate', (ctaId) => {
      // Call all ctaActivate events here
    })
    .on('ctaFormSubmitSuccess', (ctaId, mappedData, ctaName) => {
      // Call all ctaFormSubmitSuccess events here
    });
};



// WEBPACK FOOTER //
// ./scriptPartials/hubSpecificFunctions/_english.js